import { API } from '../helpers/fetcher'

export const directDebitRequest = async params =>
  API.post('v1/direct-debit', params)
